import { EditNameModalRef } from 'basic-ui-lib/components/Modal/EditNameModal';
import { useRef } from 'react';
import { useModalConfirmRef } from 'widgets/ModalConfirm';
import useGetManageLibrary from './useGetManageLibrary';
import { useDeleteMediaItem } from './useDeleteMediaItem';
import { IcCopy, IcEdit, IcTrash } from 'basic-ui-lib';
import { IMediaItem, MediaType } from 'modules/media/interfaces/api';
import mediaApis from '../apis';
import toast from 'utils/toast';

interface UseMediaMoreActionProps {
  currentPath: string;
}

export const useMediaMoreAction = ({ currentPath }: UseMediaMoreActionProps) => {
  const modalConfirmRef = useModalConfirmRef();
  const editNameModalRef = useRef<EditNameModalRef>(null);
  const [, mutate] = useGetManageLibrary(true);

  const { deleteItem } = useDeleteMediaItem({
    currentPath,
  });

  const getListMenu = (record: IMediaItem) => [
    {
      key: 'edit_name',
      title: 'Edit Name',
      icon: <IcEdit width={16} height={16} />,
    },
    ...(record.type !== MediaType.FOLDER) ? [
    {
      key: 'copy_link',
      title: 'Copy Link',
      icon: <IcCopy width={16} height={16} />,
    },
    ] : [],
    {
      key: 'delete_media',
      title: 'Delete',
      icon: <IcTrash width={16} height={16} />,
    },
  ];

  const handleDelete = (item: IMediaItem) => {
    modalConfirmRef.current?.open(() => deleteItem(item), {
      message: `Do you want to delete this ${item.type.toLowerCase()}?`,
    });
  };

  const handleEditName = async (id: string, newName: string) => {
    await mediaApis.renameMediaItem(id, newName);
    toast.success('Name updated successfully');
    mutate(currentPath);
  };

  const handleMenuClick = (menuItem: any, record: IMediaItem) => {
    switch (menuItem.key) {
      case 'edit_name':
        editNameModalRef.current?.open({
          currentName: record.name,
          id: record.id,
          onFinish: handleEditName,
        });
        break;
      case 'copy_link':
        navigator.clipboard.writeText(record.url || '');
        toast.success('Link copied to clipboard');
        break;
      case 'delete_media':
        handleDelete(record);
        break;
      default:
        break;
    }
  };

  return {
    getListMenu,
    handleMenuClick,
    modalConfirmRef,
    editNameModalRef,
  };
};
